module.exports = __webpack_public_path__ + "static/media/what-visualization.1556d65a.png";